<div class="details-item mb-3">
  <ng-container *ngIf="loading">
    <p-skeleton height="0.8rem" width="80%" styleClass="mb-1"></p-skeleton>
    <p-skeleton></p-skeleton>
  </ng-container>

  <ng-container *ngIf="!loading">
    <h5>
      {{ title }}
      <span
        *ngIf="helpTitle"
        class="text-xs font-italic text-blue-500 font-normal"
      >
        {{ helpTitle }}
      </span>
      <span class="error" title="Υποχρεωτικό πεδίο" *ngIf="isRequired">*</span>
    </h5>
    <p
      *ngIf="
        valueType === 'text' ||
        valueType === 'number' ||
        valueType === 'dropdown' ||
        valueType === 'multiple'
      "
      [style]="{ color: getColorBySeverity() }"
    >
      {{ value ?? "-" }}
    </p>
    <p *ngIf="valueType === 'date'" [style]="{ color: getColorBySeverity() }">
      {{ toDateString(value) }}
    </p>
    <p
      *ngIf="valueType === 'richtext'"
      [innerHTML]="getSafeHtml(value ?? '-')"
      [style]="{ color: getColorBySeverity() }"
    ></p>

    <div *ngIf="valueType === 'file'">
      <p-image
        *ngIf="fileExtention() === 'image'"
        [src]="
          value?.fileUrl ??
          value?.objectURL?.changingThisBreaksApplicationSecurity
        "
        [alt]="value?.fileName"
        [preview]="true"
        width="200"
        styleClass="mt-2"
      />
      <div
        *ngIf="fileExtention() !== 'image'"
        class="flex align-items-center gap-1"
      >
        <i
          class="pi pi-{{ fileExtention() }} mt-1"
          [style]="{
            color: severity
              ? getColorBySeverity()
              : !value?.fileUrl && !value?.fileName
              ? 'var(--red-400)'
              : 'var(--blue-600)'
          }"
        ></i>
        <p
          *ngIf="!value?.fileName && !value?.name"
          class="mt-1"
          [style]="{
            color: severity ? getColorBySeverity() : 'var(--red-400)'
          }"
          style="font-weight: 600"
        >
          Δεν ορίστηκε αρχείο
        </p>
        <a *ngIf="value?.fileUrl" [href]="value?.fileUrl" target="_blank">
          {{ value?.fileName ?? value?.name }}
        </a>
        <span *ngIf="!value?.fileUrl">
          {{ value?.fileName ?? value?.name }}
        </span>
      </div>
    </div>

    <p-message
      *ngIf="valueType === 'bit'"
      styleClass="mt-2"
      [text]="isBoolean(value) ? (value ? 'ΝΑΙ' : 'ΟΧΙ') : 'ΟΧΙ'"
      [severity]="severity ? severity : value === true ? 'success' : 'error'"
    />

    <ng-content *ngIf="valueType === 'custom'"></ng-content>
  </ng-container>
</div>
